import { AdminPaymethod } from '../model/adminPaymethod';
export class AdminPaymethodBuilder {
    static buildAdminPaymethod(data) {
        let p = new AdminPaymethod();
        p.id = data.id;
        p.id_client = data.id_client;
        p.type = data.type;
        p.id_company = data.id_company;
        p.id_costcenter = data.id_costcenter;
        p.alias = data.alias;
        p.lastcardnumbers = data.lastcardnumbers;
        p.expiration_month = data.expiration_month;
        p.expiration_year = data.expiration_year;
        p.added = data.added ? new Date(data.added) : null;
        p.checked = data.checked ? new Date(data.checked) : null;
        p.provider = data.provider;
        return p;
    }
}
//# sourceMappingURL=adminPaymethod-builder.js.map